<template>
  <b-overlay>
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>ایجاد دوره</h1>
          <b-row>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="انتخاب زبان دوره" label-for="lang">
                  <v-select
                    id="lang"
                    dir="rtl"
                    v-if="languagesList"
                    :reduce="(persianTitle) => persianTitle.languageId"
                    v-model="courseDetails.languageId"
                    :options="languagesList"
                    label="persianTitle"
                    placeholder="زبان مورد نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ زبانی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="انتخاب سطح دوره" label-for="courseType">
                  <v-select
                    id="courseType"
                    dir="rtl"
                    v-if="courseTypes"
                    :reduce="(title) => title.courseTypeId"
                    v-model="courseDetails.courseTypeId"
                    :options="courseTypes"
                    label="title"
                    placeholder="سطح مورد نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ سطحی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="پیش نیاز دوره" label-for="courseId">
                  <v-select
                    id="courseId"
                    dir="rtl"
                    v-if="courseList"
                    :reduce="(title) => title.courseId"
                    v-model="courseDetails.dependency"
                    :options="courseList"
                    label="title"
                    placeholder="پیش نیاز این دوره نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ پیش نیازی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="نام دوره" label-for="title">
                  <b-form-input
                    id="title"
                    v-model="courseDetails.title"
                    trim
                    placeholder="نام دوره"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="توضیحات زمان دوره" label-for="duration">
                  <b-row>
                    <b-col cols="12" md="6">
                      تعداد ساعت
                      <b-form-input
                        type="number"
                        id="duration"
                        v-model="durationHourSplited"
                        trim
                        placeholder="8"
                      />
                    </b-col>
                    <b-col cols="12" md="6">
                      تعداد دقیقه
                      <b-form-input
                        type="number"
                        id="duration"
                        v-model="durationMinuteSplited"
                        trim
                        placeholder="15"
                      />
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="عکس دوره" label-for="imageFile">
                  <b-form-file
                    id="imageFile"
                    v-model="courseImage"
                    accept="image/*"
                    @input="convertImageFileToBase64"
                  ></b-form-file>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <div v-if="courseImage">
                <p>پیشنمایش تصویر دوره</p>
                <div class="position-relative">
                  <img
                    style="width: 100%; max-height: 10rem; object-fit: contain"
                    :src="imagePreview"
                    alt=""
                  />
                  <feather-icon
                    icon="Trash2Icon"
                    size="25"
                    class="text-danger position-absolute"
                    style="left: 1rem; top: 1rem; cursor: pointer"
                    @click="deletePreviewImage"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group label="دسته بندی های دوره">
                <b-row>
                  <b-col cols="4" md="2">
                    <b-form-checkbox
                      v-model="courseDetails.vocabScore"
                      id="vocabScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> دایره کلمات </small>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="courseDetails.grammerScore"
                      id="grammerScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> گرامر </small>
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="4" md="2">
                    <b-form-checkbox
                      v-model="courseDetails.speedScore"
                      id="speedScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> سرعت </small>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="courseDetails.accentScore"
                      id="accentScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> لحجه </small>
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="4" md="2">
                    <b-form-checkbox
                      v-model="courseDetails.pronunciationScore"
                      id="pronunciationScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> تلفظ </small>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="courseDetails.listeningScore"
                      id="listeningScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> شنیداری </small>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <small>خلاصه دوره</small>
              <quillEditor
                class="mt-1"
                v-model="courseDetails.description"
                :options="editorOption"
              />
            </b-col>
          </b-row>
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              class="my-2"
              @click="sendCourseCreateRequest"
            >
              ثبت
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetAllLanguages } from "../../../libs/Api/Language";
import { GetCourseTypes } from "../../../libs/Api/CourseType";
import { CreateACourse, GetAllCourses } from "../../../libs/Api/Course";
import vSelect from "vue-select";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  mounted() {
    this.getAllLanguages();
    this.getAllCourseTypes();
    this.getAllCourses();
  },
  data() {
    return {
      isLoading: false,
      courseDetails: {
        courseId: 0,
        courseTypeId: null,
        languageId: null,
        dependency: null,
        createDate: new Date(Date.now()),
        title: null,
        imageFile: null,
        duration: null,
        description: null,
        vocabScore: false,
        grammerScore: false,
        speedScore: false,
        accentScore: false,
        pronunciationScore: false,
        listeningScore: false,
      },
      courseImage: null,
      languagesList: null,
      courseTypes: null,
      courseList: null,
      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
      tempHour: null,
      tempMinute: null,
    };
  },
  methods: {
    renderModal() {
      this.$bvModal.show("property-create");
    },
    deletePreviewImage() {
      this.courseImage = null;
      this.courseDetails.imageFile = null;
    },
    convertImageFileToBase64() {
      const reader = new FileReader();
      reader.readAsDataURL(this.courseImage);
      reader.onload = () => {
        this.courseDetails.imageFile = reader.result.split(",")[1];
      };
    },
    async sendCourseCreateRequest() {
      let _this = this;
      this.courseDetails.duration = `${this.tempHour}:${this.tempMinute}`;
      if (this.courseDetails.duration == ":") {
        this.courseDetails.duration = null;
      }
      try {
        this.isLoading = true;
        let createACourse = new CreateACourse(_this);
        createACourse.setRequestParamDataObj(_this.courseDetails);
        await createACourse.fetch(function (res) {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "دوره با موفقیت ساخته شد",
                icon: "PackageIcon",
                variant: "success",
              },
            });
            _this.courseDetails = {
              courseId: 0,
              courseTypeId: null,
              languageId: null,
              dependency: null,
              createDate: new Date(Date.now()),
              title: null,
              imageFile: null,
              duration: null,
              description: null,
            };
            _this.getAllCourses();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllCourses() {
      let _this = this;
      let getAllCourses = new GetAllCourses(_this);
      getAllCourses.setRequestParam({
        count: 10,
        pageNumber: 1,
      });
      await getAllCourses.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseList = response.data.courses;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async getAllCourseTypes() {
      let _this = this;
      let getCourseTypes = new GetCourseTypes(_this);
      getCourseTypes.setParams({
        count: 10,
        pageNumber: 1,
      });
      await getCourseTypes.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseTypes = response.data.courseTypes;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async getAllLanguages() {
      let _this = this;
      let getAllLanguages = new GetAllLanguages(_this);
      getAllLanguages.setRequestParam({
        count: 10,
        pageNumber: 1,
      });
      await getAllLanguages.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.languagesList = response.data.languages;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
  },
  computed: {
    durationHourSplited: {
      set(value) {
        this.tempHour = value;
      },
      get() {
        let time = JSON.parse(JSON.stringify(this.courseDetails?.duration));
        let hour = time?.split(":");
        if (hour && hour[0]) {
          return hour[0];
        } else {
          return null;
        }
      },
    },
    durationMinuteSplited: {
      set(value) {
        this.tempMinute = value;
      },
      get() {
        let time = JSON.parse(JSON.stringify(this.courseDetails?.duration));
        let minute = time?.split(":");
        if (minute && minute[1]) {
          return minute[1];
        } else {
          return null;
        }
      },
    },
    imagePreview() {
      if (this.courseImage) {
        return URL.createObjectURL(this.courseImage);
      }
    },
  },
  components: {
    vSelect,
    quillEditor,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BFormInput,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
